import { Cross2Icon } from '@radix-ui/react-icons';
import { Table } from '@tanstack/react-table';

import { Button } from '@/components/ui/button.tsx';
import { Input } from '@/components/ui/input.tsx';

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DeviceMetricsTableToolbar<TData>({ table }: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filter parameters..."
          value={(table.getColumn('_field')?.getFilterValue() as string) ?? ''}
          onChange={(event) => table.getColumn('_field')?.setFilterValue(event.target.value)}
          className="h-8 w-[150px] bg-white lg:w-[250px]"
        />
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
